import service from '@/plugins/service'

const exportDataApi = {}

const baseURL = '/device'

exportDataApi.exportExcel = (exportType) => {
  return service({
    url: `${baseURL}/export/${exportType}`,
    method: 'get',
    responseType: 'blob'
  })
}

export default exportDataApi
